export const MAX_VISIBLE_REWARDS_COUNT = 3
